module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('canvas', {
    ref: "canvas"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab82bbd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PieChart.vue
// module id = 1487
// module chunks = 1